import React from 'react'
import { Link } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { DashboardLayout } from '../../patientLayouts'
import PatientDetails from '../../components/PatientDetailsInfo/PatientDetails'
import { useParams } from 'react-router-dom'
import makeStyles from '@material-ui/core/styles/makeStyles'

const PatientDetailsInfo = () => {
  const params = useParams()
  const classes = useStyles()
  return (
    <DashboardLayout>
      {/* <Link to="/patient/selectPatient" className={classes.navLink}>
        <button className={classes.Backbtn}>
          <IoIosArrowBack className={classes.Backicon} />
          Select Patient Account
        </button>
      </Link> */}
      <PatientDetails appointmentId={params.appointment_id} />
    </DashboardLayout>
  )
}

export default PatientDetailsInfo

const useStyles = makeStyles(() => ({
  Backbtn: {
    marginRight: '20px',
    background: 'none',
    border: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    color: '#333',
    cursor: 'pointer',
    marginBottom: '15px',
    '@media (max-width:550px)': {
      marginBottom: '0px'
    }
  },
  Backicon: {
    marginRight: '5px'
  }
}))
